import React, { FunctionComponent } from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import { Box } from '@material-ui/core';
import useStyles from './styles';

type TProps = {
  size?: number;
  margin?: string;
  centered?: boolean;
};

export const CircularLoader: FunctionComponent<TProps> = ({
  size = 40,
  margin,
  centered,
}) => {
  const classes = useStyles({ margin });

  return (
    <Box className={centered ? classes.boxCentered : ''}>
      <CircularProgress className={classes.progress} size={size} />
    </Box>
  );
};

export default CircularLoader;
